<template lang="pug">
.container-restricao.row
    .col-8
        small Foram detectadas sobreposições pela Amazônia Protege:

        .list-group
            a.list-group-item.list-group-item-action
                .row.text-left
                    label.col-6 Nº da ação civil pública

                    label.col-5 Área do desmatamento (ha)

            a.list-group-item.list-group-item-action(
                v-for='(restricao, index) in amazoniaProtege.restricoes'
            )
                div(
                    @mouseover='highlightGeometry(restricao, "over", index)',
                    @mouseleave='highlightGeometry(restricao, "leave", index)'
                )
                    .row.text-left
                        .col-6
                            span {{ restricao.properties.numeroAcp || '-' }}

                        .col-5
                            span {{ formatNumber(restricao.properties.areaHa) }}

    .col-4
        mapa(
            v-if='layersMaps',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :locked='true',
            :height='"180px"',
            :idMapa='"mapaRestricaoAmazoniaProtege"'
        )
</template>

<script>
import formatters from '../../../utils/formatters';

import LayerStyle from '../../../utils/layerStyles';

import Mapa from '../../../components/MapaLeaflet';

export default {
    name: 'AmazoniaProtege',

    components: {
        Mapa
    },

    data() {
        return {
            layersMaps: null,
            mapConfig: {
                controls: {
                    fullscreen: true
                }
            }
        };
    },
    props: {
        amazoniaProtege: {
            type: Object,
            required: true
        },

        geometriaAreaMonitorada: {
            type: Object,
            require: true
        }
    },
    methods: {
        highlightGeometry(restricao, overOrLeave, index) {
            restricao.overOrLeave = overOrLeave;
            restricao.index = index;
            this.$emit('highlightGeometry', restricao);
        },
        formatNumber(number) {
            return formatters.formatNumber(number, 2);
        },

        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: 'Área Monitorada',
                geoJson: this.geometriaAreaMonitorada
            };

            this.layersMaps.push(layerAreaMonitorada);

            this.amazoniaProtege.restricoes.forEach(feature => {
                let layerRestricao = {
                    style: LayerStyle.RESTRICAO(),
                    geoJson: feature.geometry,
                    name: 'Amazônia Protege',
                    tooltip: `ACP ${
                        feature.properties.numeroAcp
                    }: ${this.formatNumber(feature.properties.areaHa)} ha`
                };

                this.layersMaps.push(layerRestricao);
            });
        }
    },
    mounted() {
        this.configureLayersMapa();
    }
};
</script>
